import React from 'react';
import { motion } from 'framer-motion';
export function EmpathySection() {
  const painPoints = ['Guardas ideas y consejos… pero al final no eliges nada.', 'Te emocionas, luego dudas, y te dices: "cuando tenga más tiempo".', 'Te comparas y piensas que vas tarde.', 'Quieres hacer algo propio, pero te frena el "¿quién soy yo para vender?".', 'Te abruma el día a día y tus metas quedan para después.'];
  return <section className="py-20 px-4 bg-white" data-id="element-11">
      <div className="max-w-3xl mx-auto" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-serif text-brown-800 mb-4" data-id="element-14">
            Si te sientes perdida, no es porque no puedas. <br data-id="element-15" />
            <span className="text-terracotta-500" data-id="element-16">
              Es porque nadie te dio un mapa.
            </span>
          </h2>
          <p className="text-lg text-stone-600 font-medium" data-id="element-17">
            Tal vez te pasa esto:
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-18">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream-50 border-l-4 border-terracotta-500 p-6 rounded-r-lg shadow-sm hover:shadow-md transition-shadow" data-id="element-19">
              <p className="text-lg text-brown-800" data-id="element-20">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="mt-12 text-center bg-cream-100 p-8 rounded-2xl" data-id="element-21">
          <p className="text-xl md:text-2xl font-serif text-brown-800 italic" data-id="element-22">
            "La frustración no es no tener ideas. La frustración es sentir que
            podrías… pero no sabes por dónde empezar."
          </p>
        </motion.div>
      </div>
    </section>;
}